import { lpbuilder } from "./cliente.js";

export const entrarLocal = ({ usuarioId, corp }) =>
    lpbuilder({
        method: "post",
        url: "/dev/login",
        body: { usuario_id: usuarioId, corp },
    });
